
import Ranking from '@/views/ranking/Ranking.vue'

export default [
  {
    path: 'ranking',
    name: 'ranking',
    component: Ranking
  }
]
